export default {"src":"/_next/static/image/public/images/ic_bookmark_blue_circle.c8962e6feda14574505cf3170c5ea62f.svg","height":28,"width":28};